import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bread-crumbs-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" <v-breadcrumbs\n      :items=\"items\"\n    >\n      <template #divider>\n        <v-icon>mdi-chevron-right</v-icon>\n      </template>\n    </v-breadcrumbs> ")
    ]));
}
